import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";
import ReactGA from "react-ga4";
import fetch from "auth/FetchInterceptor";
import { END_POINTS } from "constants/APIConstant";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";
import {
  dataRequestDefaultValues,
  dataRequestSchema,
} from "./dataRequestSchema";
import { buildDataRequestPayload } from "./utils";

async function postDataRequest(data) {
  return fetch.post(END_POINTS.DATA_REQUEST, buildDataRequestPayload(data));
}

export function useDataRequestForm() {
  const dir = useSelector(({ theme }) => theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const userInfo = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();

  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(dataRequestSchema),
    defaultValues: dataRequestDefaultValues,
  });
  const { errors } = formState;

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.DATA_REQUEST_DEPARTMENT_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.DATA_REQUEST_DEPARTMENT_ID}`,
  });

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => clearTimeout(timeOut);
  }, []);

  useEffect(() => {
    ReactGA.initialize(END_POINTS.TRACKING_ID);
    ReactGA.send({
      hitType: "pageview",
      page: "/datarequest",
      title: "DataRequest Page",
    });
  }, []);

  const onSubmit = async (data) => {
    try {
      const result = await postDataRequest(data);
      if (result?.state) {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: <FormattedMessage id="sent-successfully" />,
            messageType: MESSAGE_TYPE.SUCCESS,
          })
        );
      } else {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: result?.data?.message ? (
              result.data.message
            ) : (
              <FormattedMessage id="timeout-error" />
            ),
            messageType: MESSAGE_TYPE.ERROR,
          })
        );
      }
    } catch (error) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: error?.response?.data?.message ? (
            error.response.data.message
          ) : (
            <FormattedMessage id="timeout-error" />
          ),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
  };

  return {
    dir,
    currentLocale,
    userInfo,
    isLoading: getDepartment.isLoading || getServices.isLoading,
    register,
    handleSubmit,
    errors,
    onSubmit,
    getDepartment,
    servicesTools: getServices?.data?.data,
  };
}
